// temp file for helper function to get stores with composition api

import { useStore as useVuexStore } from '@nuxtjs/composition-api';
import { computed } from 'vue';
import { IRootState, TSiteConfigState } from './types';
import { IGamesState } from './games/types';
import { IInventoryState } from './inventory/types';
import { INodesState } from './nodes/types';
import { INotificationsState } from './notifications/types';
import { IProfileState } from './profile/types';
import { IShareConfigState } from './share/types';
import { IW3wState } from './web3_wallet/types';
import { ICustomRevealState } from './customReveal/types';

interface IAppStates extends IRootState {
  games: IGamesState;
  inventory: IInventoryState;
  nodes: INodesState;
  notifications: INotificationsState;
  profile: IProfileState;
  share: IShareConfigState;
  web3wallet: IW3wState;
  customReveal: ICustomRevealState;
}

export const useStore = () => useVuexStore<IAppStates>();
export const useSiteConfigState = () => {
  const store = useStore();
  return computed<TSiteConfigState>(() => store.getters['siteConfig']);
};
